import { usePhoneNumberFormatter } from "@/ContactDirectory/Hooks/usePhoneNumberFormatter";
import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models//DirectoryHealthCareProvider";

import styles from "./ExternalConsultantsComponent.module.scss";

interface IFaxDirectorySearchHealthCareProviderComponentProps {
    healthCareProvider: DirectoryHealthCareProvider;
    showContacts?: boolean;
}

export function HealthCareProviderInClinicSearchResultItemComponent(props: IFaxDirectorySearchHealthCareProviderComponentProps): JSX.Element {
    const healthCareProvider = props.healthCareProvider;
    const linkedEstablishment = healthCareProvider.linkedEstablishments?.firstOrDefault();
    const address = linkedEstablishment?.address;
    const formatPhoneNumber = usePhoneNumberFormatter(address?.countryId, address?.stateId);

    if (!healthCareProvider)
        return null;

    const phoneNumber = linkedEstablishment?.phoneNumbers?.firstOrDefault();
    const faxNumber = healthCareProvider.linkedFaxNumbers?.firstOrDefault();

    return (
        <div key={healthCareProvider.id}>
            <ul>
                <li className={`blue ${styles.subtitle}`}>
                    {healthCareProvider.getDisplayName()}
                </li>
                {props.showContacts && (
                    <>
                        <li>{address?.toString()}</li>
                        <li>{`T: ${formatPhoneNumber(phoneNumber)}`}<span className="separator">|</span>{`F: ${formatPhoneNumber(faxNumber)}`}</li>
                    </>
                )}
            </ul>
        </div>
    );
}
